// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Casino iframe styles – iOS Safari playbook
 * See docs/casino-iframe-ios-playbook.md
 * DO NOT use 100vh for iframe or wrapper; use var(--app-height) from index.html script.
 *
 * Overrides: public/css/style.css has body.casino-game-playing .slot-iframe.show with
 * 100vh/min-height/max-height and .slot-iframe.show iframe with calc(100vh - 40px).
 * This file overrides those with var(--app-height) and 100% height so iOS Safari works.
 */

/* ─── Body: disable scroll when game is open ─── */
body.casino-game-playing {
  overflow: hidden !important;
}

/* Override style.css 100vh for iframe – use 100% so wrapper's var(--app-height) controls height */
body.casino-game-playing .slot-iframe.show iframe {
  width: 100% !important;
  height: 100% !important;
  min-height: unset !important;
  border: none !important;
}

/* ─── Wrapper: fullscreen with real viewport height; override style.css 100vh ─── */
.casino-page-wrap .slot-iframe.show,
body.casino-game-playing .casino-page-wrap .slot-iframe.show,
body.casino-game-playing .slot-iframe.show {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--app-height, 100vh) !important;
  min-height: unset !important;
  max-height: unset !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #000;
  touch-action: manipulation;
  -webkit-overflow-scrolling: touch;
  z-index: 99999;
}

/* ─── iframe: fill wrapper + GPU hints to reduce Safari freeze ─── */
.casino-page-wrap .slot-iframe.show iframe,
body.casino-game-playing .slot-iframe.show iframe {
  flex: 1 1;
  width: 100%;
  height: 100%;
  border: none;
  transform: translateZ(0);
  will-change: transform;
}

/* ─── Loading: hourglass (while fetching URL or during 120ms delay) ─── */
.slot-iframe .slot-iframe-loading {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.slot-iframe .slot-iframe-loading .lds-hourglass {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.slot-iframe .slot-iframe-loading .lds-hourglass::after {
  content: " ";
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin: 8px;
  box-sizing: border-box;
  border: 32px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: casino-lds-hourglass 1.2s infinite;
}

@keyframes casino-lds-hourglass {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  100% {
    transform: rotate(1800deg);
  }
}

/* ─── Hide top bar (game name + EXIT) on mobile – full height for game, use device back ─── */
@media (max-width: 768px) {
  .casino-page-wrap .slot-iframe .slot-header,
  .slot-iframe .slot-header {
    display: none !important;
  }
}

/* ─── Hide page content when game is open – prevents repaint/freeze ─── */
body.casino-game-playing .casino-page-wrap > *:not(.slot-iframe) {
  visibility: hidden !important;
}

body.casino-game-playing .casino-page-wrap > .slot-iframe.show {
  visibility: visible !important;
}

/* ─── Image loading performance: casino list item banner (img fill + blank on error) ─── */
.casino-list-item .casino-list-item-banner {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}
.casino-list-item .casino-list-item-banner picture {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.casino-list-item .casino-list-item-banner img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.casino-list-item .casino-list-item-banner--blank {
  background-color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/casino/casino.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF,mDAAmD;AACnD;EACE,2BAA2B;AAC7B;;AAEA,kGAAkG;AAClG;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,oFAAoF;AACpF;;;EAGE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,2CAA2C;EAC3C,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,cAAc;AAChB;;AAEA,qEAAqE;AACrE;;EAEE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE;IACE,oBAAoB;IACpB,iEAAiE;EACnE;EACA;IACE,yBAAyB;IACzB,8DAA8D;EAChE;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,8FAA8F;AAC9F;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,0EAA0E;AAC1E;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/**\n * Casino iframe styles – iOS Safari playbook\n * See docs/casino-iframe-ios-playbook.md\n * DO NOT use 100vh for iframe or wrapper; use var(--app-height) from index.html script.\n *\n * Overrides: public/css/style.css has body.casino-game-playing .slot-iframe.show with\n * 100vh/min-height/max-height and .slot-iframe.show iframe with calc(100vh - 40px).\n * This file overrides those with var(--app-height) and 100% height so iOS Safari works.\n */\n\n/* ─── Body: disable scroll when game is open ─── */\nbody.casino-game-playing {\n  overflow: hidden !important;\n}\n\n/* Override style.css 100vh for iframe – use 100% so wrapper's var(--app-height) controls height */\nbody.casino-game-playing .slot-iframe.show iframe {\n  width: 100% !important;\n  height: 100% !important;\n  min-height: unset !important;\n  border: none !important;\n}\n\n/* ─── Wrapper: fullscreen with real viewport height; override style.css 100vh ─── */\n.casino-page-wrap .slot-iframe.show,\nbody.casino-game-playing .casino-page-wrap .slot-iframe.show,\nbody.casino-game-playing .slot-iframe.show {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--app-height, 100vh) !important;\n  min-height: unset !important;\n  max-height: unset !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #000;\n  touch-action: manipulation;\n  -webkit-overflow-scrolling: touch;\n  z-index: 99999;\n}\n\n/* ─── iframe: fill wrapper + GPU hints to reduce Safari freeze ─── */\n.casino-page-wrap .slot-iframe.show iframe,\nbody.casino-game-playing .slot-iframe.show iframe {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  border: none;\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n/* ─── Loading: hourglass (while fetching URL or during 120ms delay) ─── */\n.slot-iframe .slot-iframe-loading {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n}\n\n.slot-iframe .slot-iframe-loading .lds-hourglass {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.slot-iframe .slot-iframe-loading .lds-hourglass::after {\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  width: 0;\n  height: 0;\n  margin: 8px;\n  box-sizing: border-box;\n  border: 32px solid #fff;\n  border-color: #fff transparent #fff transparent;\n  animation: casino-lds-hourglass 1.2s infinite;\n}\n\n@keyframes casino-lds-hourglass {\n  0% {\n    transform: rotate(0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n  50% {\n    transform: rotate(900deg);\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  100% {\n    transform: rotate(1800deg);\n  }\n}\n\n/* ─── Hide top bar (game name + EXIT) on mobile – full height for game, use device back ─── */\n@media (max-width: 768px) {\n  .casino-page-wrap .slot-iframe .slot-header,\n  .slot-iframe .slot-header {\n    display: none !important;\n  }\n}\n\n/* ─── Hide page content when game is open – prevents repaint/freeze ─── */\nbody.casino-game-playing .casino-page-wrap > *:not(.slot-iframe) {\n  visibility: hidden !important;\n}\n\nbody.casino-game-playing .casino-page-wrap > .slot-iframe.show {\n  visibility: visible !important;\n}\n\n/* ─── Image loading performance: casino list item banner (img fill + blank on error) ─── */\n.casino-list-item .casino-list-item-banner {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 0;\n}\n.casino-list-item .casino-list-item-banner picture {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.casino-list-item .casino-list-item-banner img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.casino-list-item .casino-list-item-banner--blank {\n  background-color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
